import AccessDeniedAnimation from "components/access-denied-animation";
import styled from "styled-components";

const WrapperDiv = styled.div`
  width: 331px;
`;

const BlurDiv = styled.div`
  top: 0;
  position: absolute;
  height: 87px;
  border-radius: 1508px;
  opacity: 0.21;
  background: #3444da;
  filter: blur(141.4550018310547px);
  opacity: 0.6;
`;

const BottomBlurDiv = styled.div`
  border-radius: 1508px;
  opacity: 0.21;
  background: #3444da;
  filter: blur(141.4550018310547px);
  width: 1508px;
  height: 180px;
  flex-shrink: 0;
  position: absolute;
  bottom: 0;
`;

function SanctionAccessDenied() {
  return (
    <div
      className="mx-auto flex flex-col min-h-screen"
      data-testid="access-denied-page"
    >
      <div className="relative flex flex-col items-center flex-1 justify-center">
        <BlurDiv className="w-full" />
        <WrapperDiv>
          <AccessDeniedAnimation />
          <div className="mt-6">
            <p className="text-gray-800 text-center text-[20px] font-semibold ">
              We're Sorry!
            </p>
            <p className="text-gray-380 text-center text-[16px] font-normal mt-2.5">
              micro1 is currently not available
              in your region. We hope to serve you in the future.
            </p>
          </div>
        </WrapperDiv>
        <BottomBlurDiv className="w-full" />
      </div>
    </div>
  );
}

export default SanctionAccessDenied;
